import { useRef, useState } from "react";
import { Input } from "antd";
import { TextAreaProps } from "antd/lib/input";
import { TextAreaRef } from "antd/lib/input/TextArea";

interface FloatInputProps extends TextAreaProps {
    label: string,
}

const FloatTextArea = (props: FloatInputProps) => {
    const [focus, setFocus] = useState(false);
    let { label, placeholder, required, ...rest } = props;

    if (!placeholder) placeholder = label;

    //   const isOccupied = focus || (value && value.length !== 0);
    const isOccupied = focus || (rest.value);

    const labelClass = isOccupied ? "label as-label" : "label as-placeholder";

    const requiredMark = required ? <span className="text-danger">*</span> : null;

    return (
        <div
            className="custom-input"
            onBlur={() => setFocus(false)}
            onFocus={() => setFocus(true)}
        >
            <Input.TextArea style={{ resize: "none" }} {...rest} />
            <label className={labelClass}>
                {isOccupied ? label : placeholder} {requiredMark}
            </label>
        </div>
    );
};

export default FloatTextArea;
